/* eslint-disable */
import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Upload, Input, message, Divider, Row, Col } from "antd";
import { useQueryClient } from "react-query";
import "../../style/style.css";
import api from "../../adapter/base";

const formlayout = {
  labelCol: {
    span: 20,
  },
  wrapperCol: {
    span: 24,
  },
};
const uploadButton = (
  <div>
    <PlusOutlined />
    <div
      style={{
        marginTop: 8,
      }}
    >
      Upload
    </div>
  </div>
);
const RegisterCorporateEmployee = ({ UpdateCorporateIdToChildComponent }) => {
  const [form] = Form.useForm();
  const [load, setLoad] = useState(false);
  const [counter, setCounter] = useState(0);
  const client = useQueryClient();
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    setCounter((counter) => counter + 1);
    return e?.fileList;
  };
  const onFinish = (values) => {
    Object.keys(values).map((key) => {
      if (
        Object.is(values[key], null) ||
        Object.is(values[key], undefined) ||
        Object.is(values[key], "")
      ) {
        delete values[key];
        return;
      }
    });
    setLoad(true);
    const fd = new FormData();
    if (values["upload"]?.length) {
      fd.append(
        "profile_image",
        values["upload"][0].originFileObj,
        values["upload"][0].originFileObj.name
      );
      delete values["upload"];
    } else {
      delete values["upload"];
    }
    Object.keys(values).map((key) => {
      if (
        key === "city" ||
        key === "sub_city" ||
        key === "woreda" ||
        key === "neighborhood" ||
        key === "house_number"
      ) {
        fd.append(`address[${key}]`, values[key]);
        return;
      }
      fd.append(key, values[key]);
    });
    fd.append("corporate_id", UpdateCorporateIdToChildComponent);
    api
      .post("users", fd)
      .then((res) => {
        message.success("Registered successfully");
        form.resetFields();
        client.invalidateQueries("corporates");
      })
      .catch((err) => {
        message.error(err.response.data.message);
      });
  };
  return (
    <div className="registercorporateform">
      <h2>+ ሰራተኛ መመዝገቢያ</h2>
      <Divider />
      <Form
        name="validate_other"
        onFinish={onFinish}
        form={form}
        layout="vertical"
        {...formlayout}
        style={{
          maxWidth: 300,
        }}
      >
        <Form.Item
          label="መለያ ስም"
          name="user_name"
          rules={[
            {
              required: true,
              message: "Please Enter UserName",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Row>
          <Col span={11}>
            <Form.Item
              label="የመጀመሪያ ስም"
              name="first_name"
              rules={[
                {
                  required: true,
                  message: "Please Enter First Name",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12} offset={1}>
            <Form.Item
              label="የአባት ስም"
              name="last_name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Last Name",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="ስልክ ቁጥር"
          name="phone_number"
          rules={[
            {
              required: true,
              message: "Please input phone Number",
            },
          ]}
        >
          <Input placeholder="251912...." maxLength={12} showCount />
        </Form.Item>

        <Form.Item
          label="ኢሜል"
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: "The input is not valid E-mail!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Divider>
          <h5>አድራሻ</h5>
        </Divider>
        <Row>
          <Col span={11}>
            <Form.Item
              label="ከተማ"
              name="city"
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12} offset={1}>
            <Form.Item
              label="ክፍለ ከተማ"
              name="sub_city"
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="ወረዳ" name="woreda">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12} offset={1}>
            <Form.Item label="ጎረቤት" name="neighborhood">
              <Input />
            </Form.Item>
          </Col>
          <Form.Item label="የቤት ቁጥር" name="house_number">
            <Input />
          </Form.Item>
        </Row>
        <Divider />
        <Form.Item
          label="የብድር መጠን"
          name="loan_amount"
          rules={[
            {
              required: true,
              message: "This field is required",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="የባንክ አካውንት"
          name="account_number"
          rules={[
            {
              required: true,
              message: "This field is required",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Row>
          <Col span={11}>
            <Form.Item
              label="ፓስዎርድ"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Password is Required",
                },
              ]}
            >
              <Input type="password" />
            </Form.Item>
          </Col>
          <Col span={12} offset={1}>
            <Form.Item
              label="እንደገና ፓስዎርድ"
              name="password_confirmation"
              rules={[
                {
                  required: true,
                  message: "please enter password confirmation",
                },
              ]}
            >
              <Input type="password" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="upload"
          label="Profile Image"
          valuePropName="fileList"
          accept=".jpg, .jpeg, .png, .bmp, .gif, .svg,.webp"
          getValueFromEvent={normFile}
          multiple={false}
        >
          <Upload
            name="logo"
            listType="picture-card"
            multiple={false}
            beforeUpload={(file) => {
              return false;
            }}
          >
            {counter < 1 && uploadButton}
          </Upload>
        </Form.Item>

        <Form.Item
          wrapperCol={{
            span: 15,
            offset: 2,
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ backgroundColor: "#F4AD33", marginTop: "12px" }}
            loading={load}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              fill="currentColor"
              className="bi bi-save"
              viewBox="0 0 16 16"
            >
              {" "}
              <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />{" "}
            </svg>
            መዝግብ
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default RegisterCorporateEmployee;
